import React from "react";

const properties = [
  {
    id: 1,
    image: "https://img.staticmb.com/mbimages/project/Photo_h310_w462/2020/08/04/Project-Photo-45-Manglams-Aananda-Jaipur-5020643_720_1280_310_462.jpeg", // Replace with actual image
    price: "₹ 1.32 Cr",
    size: "4 BHK Flat 2400 Sqft",
    status: "Ready to Move",
    description: "This independent floor is located in...",
    builder: "Manglam Group",
    posted: "Feb 08, '25",
    photosCount: 26,
  },
  {
    id: 2,
    image: "https://img.staticmb.com/mbimages/project/Photo_h310_w462/2020/08/04/Project-Photo-45-Manglams-Aananda-Jaipur-5020643_720_1280_310_462.jpeg",
    price: "₹ 72.9 Lac",
    size: "2 BHK Flat 1325 Sqft",
    status: "Ready to Move",
    description: "This independent floor is located in...",
    builder: "Manglam Group",
    posted: "Yesterday",
    photosCount: 26,
  },
  {
    id: 3,
    image: "https://img.staticmb.com/mbimages/project/Photo_h310_w462/2020/08/04/Project-Photo-45-Manglams-Aananda-Jaipur-5020643_720_1280_310_462.jpeg",
    price: "₹ 1.02 Cr",
    size: "3 BHK Flat 1865 Sqft",
    status: "Ready to Move",
    description: "This independent floor is located in...",
    builder: "Manglam Group",
    posted: "Yesterday",
    photosCount: 26,
  },
];

const PropertyCards = () => {
  return (
    <div className=" p-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {properties.map((property) => (
          <div key={property.id} className="bg-white  rounded-lg overflow-hidden">
            <div className="relative">
              <img src={property.image} alt="Property" className="w-full h-48 object-cover" />
              <div className="absolute bottom-0 bg-black bg-opacity-50 text-white text-sm p-2 flex justify-between w-full">
                <span>Posted: {property.posted}</span>
                <span>{property.photosCount} Photos</span>
              </div>
            </div>
            <div className="p-4 border">
              <h3 className="text-xl font-bold">{property.price}</h3>
              <p className="text-gray-600">{property.size}</p>
              <p className="text-green-600">{property.status}</p>
              <p className="text-gray-500 text-sm mt-2">{property.description}</p>
              <p className="text-gray-700 font-medium mt-2">Builder: {property.builder}</p>
              <button className="mt-4 w-full bg-red-500 text-white py-2 rounded-lg hover:bg-red-600">
                Contact Builder
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="text-left mt-4">
        <button className="text-red-500 font-medium hover:underline">Show all {properties.length} properties for Sale</button>
      </div>
    </div>
  );
};

export default PropertyCards;
